import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DetailViewNotifyService } from '../../shared/detailview-notify.service';
import { TranslateService } from '@ngx-translate/core';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { deLocale } from 'ngx-bootstrap/locale';
import * as moment from 'moment';
import { BaseControlComponent } from '../base-control/base-control.component';
import { DetailViewComponent } from '../../detail-view.component';
import { takeUntil } from 'rxjs/operators';

defineLocale('de', deLocale);

// Datepicker
@Component({
    selector: 'date-picker',
    templateUrl: './date-picker.component.html',
    styleUrls: ['./date-picker.component.scss'],
    standalone: false
})
export class DatePickerComponent extends BaseControlComponent implements OnInit, OnDestroy {
  @ViewChild('datePickerRef', { static: true }) datePickerRef: ElementRef;
  public currentInputDate: Date;
  public cssTheme = 'theme-black';

  constructor(
    public translate: TranslateService,
    public detailViewNotifyService: DetailViewNotifyService,
    public detailViewComponent: DetailViewComponent,
    private _bsLocaleService: BsLocaleService
  ) {
    super(detailViewNotifyService, translate);
    this._bsLocaleService.use('de');
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  protected setInitialValue() {
    if (this.detailFormDataModel.selectedFeature.attributes[this.prop.field_name]) {
      const momentDate = moment.utc(
        new Date(this.detailFormDataModel.selectedFeature.attributes[this.prop.field_name])
      );
      this.formField.setValue(momentDate.toDate());
    }
    if (!this.prop.field_editable) {
      this.formField.disable();
    }
  }

  protected specificValidateField() {
    if (this.formField.errors?.bsDate?.invalid) {
      this.translate.get('DETAIL_VIEW.FORM_VALIDATION.INVALID_DATE').pipe(takeUntil(this.unsubscribe$)).subscribe(msg => {
        this.errorMessages.push(msg);
      });
    }
  }
}
